import { render } from "./ClassForm.vue?vue&type=template&id=0ecc1713&scoped=true"
import script from "./ClassForm.vue?vue&type=script&lang=js"
export * from "./ClassForm.vue?vue&type=script&lang=js"

import "./ClassForm.vue?vue&type=style&index=0&id=0ecc1713&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ecc1713"]])

export default __exports__